import {
	GRAPHQL_GET_ACTIVE_PLATFORM_TIER_SUCCESS,
	GRAPHQL_GET_TRUSTED_CONTACT_SUCCESS,
	GRAPHQL_GET_USER_SUCCESS,
} from 'stash/actions/apolloGraphql';
import { POST_TRUSTED_CONTACT_SUCCESS } from 'stash/actions/api/trustedContact';
import {
	GET_USER_SUBSCRIPTION_SUCCESS,
	PATCH_USER_SUBSCRIPTION_SUCCESS,
	PATCH_USER_SUCCESS,
	POST_PHONE_VERIFICATION_SUCCESS,
	POST_USER_PLATFORM_TIER_SUCCESS,
	POST_USER_SUBSCRIPTION_SUCCESS,
	POST_USER_SUCCESS,
} from 'stash/actions/api';
import {
	SET_BILLING_FREQUENCIES,
	SET_BILLING_FREQUENCY,
	SET_BILLING_PERIOD,
} from 'stash/actions/signUp';

const capitalizeName = (name) => {
	if (typeof name !== 'string') {
		return '';
	}
	if (name.toLowerCase() !== name && name.toUpperCase() !== name) {
		return name;
	}
	return name.replace(/\w\S*/g, (txt) => {
		return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
	});
};

const formatNames = (user) => {
	return {
		first_name: capitalizeName(user.first_name),
		last_name: capitalizeName(user.last_name),
	};
};

const user = (state = {}, action) => {
	switch (action.type) {
		case PATCH_USER_SUCCESS:
		case GRAPHQL_GET_USER_SUCCESS:
		case POST_USER_SUCCESS:
			return {
				...state,
				...action.response.user,
				...formatNames(action.response.user),
			};
		case POST_PHONE_VERIFICATION_SUCCESS:
			return {
				...state,
				phone_number_verification: action.response.phone_number_verification,
			};
		case POST_TRUSTED_CONTACT_SUCCESS:
			return {
				...state,
				trusted_contact: action.response.trusted_contact,
			};

		// TODO: Deprecation Warning.
		case POST_USER_PLATFORM_TIER_SUCCESS: {
			const platform_tier = action.response.user_platform_tier.platform_tier;

			return {
				...state,
				platform_tier,
			};
		}

		case GET_USER_SUBSCRIPTION_SUCCESS:
		case POST_USER_SUBSCRIPTION_SUCCESS:
		case PATCH_USER_SUBSCRIPTION_SUCCESS: {
			const platform_tier = action.response.active_platform_tier.platform_tier;

			return {
				...state,
				platform_tier,
			};
		}

		// TODO: Deprecation Warning.
		case GRAPHQL_GET_ACTIVE_PLATFORM_TIER_SUCCESS: {
			const active_platform_tier = action.response.active_platform_tier;
			return {
				...state,
				platform_tier: active_platform_tier && active_platform_tier.platform_tier,
			};
		}

		case SET_BILLING_PERIOD:
			return {
				...state,
				billing_period: action.billing_period,
			};

		case SET_BILLING_FREQUENCY:
			return {
				...state,
				billing_frequency_id: action.billing_frequency_id,
			};

		case SET_BILLING_FREQUENCIES:
			return {
				...state,
				billingFrequencies: action.billingFrequencies,
			};

		case GRAPHQL_GET_TRUSTED_CONTACT_SUCCESS:
			return {
				...state,
				trusted_contact: action.response.trusted_contact,
			};

		default:
			return state;
	}
};

export default user;
